import React, { useEffect, useState } from 'react';
import './CSS/App.css';
import Button from '@mui/material/Button';
import SvgConverter from './SvgConverter';
import Trademark from './Trademark';
import SvgAdminPanel from './SvgAdminPanel';
import AppScreen from './App';
import LoginScreen from './LoginScreen';
import MaintenanceScreen from './MaintenanceScreen';
import ShopEffort from './ShopEffort';

import { BrowserRouter as Router, Route, Routes, useNavigate, Navigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { useUser } from "./Context/UserContext";
import Box from "@mui/material/Box";
import { 
  Switch, 
  FormControlLabel, 
  Paper,
  Divider,
  Select,
  MenuItem,
  FormControl
} from '@mui/material';
import { Height } from '@mui/icons-material';
import {  Card, CardContent, Typography,Avatar } from "@mui/material";
import axios from "axios";
import { set } from 'date-fns';

const CustomButton = styled(Button)({
  borderColor: 'black',
  color: 'black',
  border: '2px solid #1A1A1A',
  borderRadius: '15px',
  boxSizing: 'border-box',
  fontFamily: 'Roobert,-apple-system,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
  fontSize: '16px',
  fontWeight: 600,
  minHeight: '60px',
  padding: '16px 24px',
  transition: 'all 300ms cubic-bezier(.23, 1, 0.32, 1)',
  width: '100%',
  marginBottom: '6%',
  '&:hover': {
    color: '#fff',
    backgroundColor: '#1A1A1A',
    borderColor: 'rgba(121, 147, 81)',
    boxShadow: 'rgba(0, 0, 0, 0.25) 0 8px 15px',
    transform: 'translateY(-2px)',
  },
  '&:active': {
    boxShadow: 'none',
    transform: 'translateY(0)',
  },
  '&:disabled': {
    pointerEvents: 'none',
  },
});
const DATABASE_OPTIONS = [
  { label: "Uberty", value: "UBERTY" },
  { label: "Dış Shop", value: "UBERTYSEC" },
  { label: "Kiralık Shop", value: "UBERTYTHIRD" },
];

const Menu = () => {
  const { user, setUser } = useUser();
  const navigate = useNavigate();
  const handleLogout = () => {
    setUser(null); // Kullanıcı bilgisini temizle
    navigate("/LoginScreen"); // Kullanıcıyı giriş sayfasına yönlendir
  };
  const imageList = [
    '/Logos/HORSE.svg'
  ];

  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true); 

  useEffect(() => {
    const intervalId = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentImageIndex((prevIndex) => 
          (prevIndex + 1) % imageList.length 
        );
        setIsVisible(true); 
      }, 1000); 
      
    }, 40000); // 4 saniye

    return () => clearInterval(intervalId);
  }, [imageList.length]);

  return (
    <div className='OuterContainer'>
      <div className='MenuContainer'>
      <Avatar
          src="/Logos/HORSE HEAD.svg"
          alt="Ana Menü"
          sx={{ width: 350, height: 350 }}
        />
        <MenuComponent />
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", mt: 2 }}>
      <Card sx={{
        backgroundColor: "#f0f0f0", // Hafif gri arka plan
        border: "2px solid black", // Siyah çerçeve
        borderRadius: "12px", // Yuvarlatılmış kenarlar
        p: -1,
        minWidth: 320,
        textAlign: "center",
        boxShadow: "none", // Gölgeyi kaldırarak düz tasarım
      }}>
        <CardContent>
          <Typography variant="h6" sx={{ fontWeight: "bold", color: "black" }}>
            Welcome: {user?.Username}
          </Typography>
          <Button
            variant="contained"
            onClick={handleLogout}
            sx={{
              mt: 2,
              border: "2px solid black", // Menü butonlarına uygun siyah çerçeve
              color: "black",
              backgroundColor: "white",
              borderRadius: "10px",
              fontWeight: "bold",
              width: "100%",
              p: 1.5,
              "&:hover": {
                backgroundColor: "#e0e0e0", // Hover'da biraz koyulaşan arka plan
              },
            }}
          >
            Çıkış Yap
          </Button>
        </CardContent>
      </Card>
    </Box>
      </div>
      <div className="Divider"></div>
      <div className='LogoContainer'>
        <img 
          src={imageList[currentImageIndex]} 
          alt='Logo' 
          className={`LoopImage ${isVisible ? 'visible' : 'hidden'}`} 
        />
      </div>
    </div>
  );
};

const MenuComponent = () => {
  let status = "1";
  let path =
    status === "0" ? "http://localhost:3003" : "https://outlettee.com:3003";
  const navigate = useNavigate();
  const { user, setUser } = useUser();
  console.log(user);

  const [selectedDatabase, setSelectedDatabase] = useState(user?.DatabaseName || "UBERTY");

  const handleDatabaseChange = async (event) => {
    const newValue = event.target.value;
    const oldValue = selectedDatabase;

    setSelectedDatabase(newValue); // Önce UI'ı güncelle

    try {
      const response = await axios.post(path + "/api/updateDatabaseType", {
        UserID: user?.ID,
        DatabaseName: newValue,
      });

      if (response.status === 200) {
        setUser({
          ...user,
          DatabaseName: newValue,
        });
        console.log(`Database değişti: ${newValue}`);
      } else {
        console.error("Database switch hatası");
        setSelectedDatabase(oldValue);
      }
    } catch (error) {
      console.error("Network error:", error);
      setSelectedDatabase(oldValue);
    }
  };

  const isAdmin = user?.Admin === 1;
  const [userShop, setUserShop] = useState(false);

  const fetchShops = async () => {
    try {
      const response = await fetch(`${path}/api/getShopsByCaptainOrSelf`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          UserID: user?.ID,
          IsAdmin: isAdmin ? 1 : 0,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        console.log("Fetched Shops:", data);
        setUserShop(Array.isArray(data) && data.length > 0);
      } else {
        setUserShop(false);
      }
    } catch (error) {
      setUserShop(false);
    }
  };

  useEffect(() => {
    fetchShops();
  }, []);

  console.log("UserShop Durumu:", userShop);

  const buttons = [
    {
      id: "Converter",
      label: "Dizayn Dönüştür",
      condition: user?.Admin === 1 || user?.DesignConverter === 1,
    },
    {
      id: "SvgAdminPanel",
      label: "Dizayn Tanımla",
      condition: user?.Admin === 1 || user?.DesignResponsible === 1,
    },
    {
      id: "Trademark",
      label: "Trademark",
      condition: user?.Admin === 1 || user?.TradeMark === 1,
    },
    {
      id: "MaintenanceScreen",
      label: "Bakım Ekranları",
      condition:
        user?.Admin === 1 ||
        user?.Username === "ibrahim bagdes" ||
        user?.Username === "osman kale",
    },
    {
      id: "UserEffort",
      label: "Efor Tanımlama",
      condition: user?.Admin === 1 || user?.UserEffort === 1,
    },
    {
      id: "ShopEffort",
      label: "Shop Veri Giriş",
      condition: user?.Admin === 1 || user?.ShopEffort === 1,
    },
    {
      id: "UserReport",
      label: "Kullanıcı Raporları",
      condition: user?.Admin === 1 || user?.Reports === 1,
    },
    {
      id: "ProductStock",
      label: "Ürün Raporları",
      condition:
        user?.Username === "ibrahim bagdes" || user?.Username === "Admin",
    },
    {
      id: "SquMaintenance",
      label: "Squ Bakım Ekranı",
      condition: userShop,
    },
  ];

  const authorizedButtons = buttons.filter((button) => button.condition);

  const handleNavigation = (id) => {
    console.log(id);
    if (id === "Converter") {
      navigate("/converter");
    } else if (id === "Trademark") {
      navigate("/trademark");
    } else if (id === "SvgAdminPanel") {
      navigate("/SvgAdminPanel");
    } else if (id === "LoginScreen") {
      navigate("/LoginScreen");
    } else if (id === "MaintenanceScreen") {
      navigate("/MaintenanceScreen");
    } else if (id === "UserEffort") {
      navigate("/UserEffort");
    } else if (id === "ShopEffort") {
      navigate("/ShopEffort");
    } else if (id === "UserReport") {
      navigate("/UserReports");
    } else if (id === "ProductStock") {
      navigate("/ProductStock/UploadProduct");
    } else if (id === "SquMaintenance") {
      navigate("/SquMaintenance");
    }
  };

  return (
    <>
      <Box
        sx={{
          maxHeight: "600px",
          overflowY: "auto",
          border: "1px solid #ddd",
          padding: "16px",
          borderRadius: "8px",
        }}
      >
        <Box>
          {(user?.Admin === 1 || user?.ReportAdmin === 1) && (
            <>
              <Paper
                elevation={2}
                sx={{
                  p: 2,
                  mb: 2,
                  borderRadius: 2,
                  background:
                    "linear-gradient(135deg,rgb(247, 247, 247) 0%,rgba(95, 91, 99, 0.5) 100%)",
                  color: "black",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{ mb: 2, textAlign: "center", fontWeight: "bold" }}
                >
                  Veritabanı Seçimi
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <FormControl sx={{ minWidth: 200 }}>
                    <Select
                      value={selectedDatabase}
                      onChange={handleDatabaseChange}
                      sx={{
                        backgroundColor: "white",
                        borderRadius: "8px",
                        "& .MuiSelect-select": {
                          py: 1.5,
                          fontWeight: "bold",
                        },
                      }}
                    >
                      {DATABASE_OPTIONS.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>

                <Box sx={{ textAlign: "center", mt: 1 }}>
                  <Typography variant="body2" sx={{ opacity: 0.9 }}>
                    Aktif:{" "}
                    {DATABASE_OPTIONS.find(
                      (opt) => opt.value === selectedDatabase
                    )?.label || "Uberty"}{" "}
                    Veritabanı
                  </Typography>
                </Box>
              </Paper>

              <Divider sx={{ mb: 2 }} />
            </>
          )}
        </Box>

        {authorizedButtons.length > 0 ? (
          authorizedButtons.map((button) => (
            <CustomButton
              key={button.id}
              id={button.id}
              onClick={() => handleNavigation(button.id)}
            >
              {button.label}
            </CustomButton>
          ))
        ) : (
          <div style={{ textAlign: "center", marginTop: "20px", color: "red" }}>
            Hiçbir yetkiniz bulunmamaktadır. Lütfen yöneticiniz ile iletişime
            geçiniz.
          </div>
        )}
      </Box>
    </>
  );
};

export default Menu;
